import {createVIPDetailResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const VIPSchema = z.object({
  id: z.string(),
  name: z.string(),
  storeID: z.string(),
  value: z.number(),
  icon: z.string().nullable(),
  customerCount: z.number(),
  status: z.number(),
})

export const VIPSchemaResponse = createVIPDetailResponseSchema(VIPSchema)

export type VIP = z.infer<typeof VIPSchema>
export type VIPResponse = z.infer<typeof VIPSchemaResponse>
